var exports = {
  "Q": "BrowserLoginHandoffModal.module__content___STdhdD",
  "A": "BrowserLoginHandoffModal.module__prefillHint___STdhdD",
};

module.exports = exports;
